<template>
  <div
    :style="{'z-index': isShow ? 1 : -1}"
    class="page">
    <div class="top-bar">
      <slot name="top-bar"></slot>
    </div>
    <div class="main">
      <slot></slot>
    </div>
    <div class="bottom-bar">
      <slot name="bottom-bar"></slot>
    </div>
  </div>
</template>

<script>
export default {
  provide () {
    return {
      page: this,
      pageIsShow: this.isShow
    }
  },
  data () {
    return {
      modals: [],
      originScrollTop: undefined
    }
  },
  inject: {
    pageWrapper: {
      default () {
      }
    }
  },
  computed: {
    isShow () {
      // TODO: 切换显示状态的时候恢复滚动条位置
      const pageWrapper = this.pageWrapper
      if (pageWrapper) {
        return pageWrapper.active === this.name
      }
      return true
    }
  },
  props: ['name'],
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.page
  position absolute
  top 0
  left 0
  height 100%
  width 100%
  overflow auto
  background #fff
  display flex
  flex-direction column
.main
  flex 1
  overflow-y auto
</style>
